import React from "react";
import CollapsiblePanel from "../base/CollapsiblePanel";
import { getUser } from "../auth/Auth";
import API from "../base/API";
import OppositionFormEdit from "./OppositionFormEdit";
import OppositionCommentFormEdit from "./OppositionCommentFormEdit";
import { translate } from "../base/Translation";

export default class OppositionItem extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            "submit_comment": "/opposition/comment/:oppositionID"
        })

        this.state = {
            comment: "",
            editingComment: false,
        }
    }

    onCommentChange(evt) {
        this.setState({ comment: evt.target.value });
    }

    onSubmitComment() {
        if (this.state.comment === "") {
            alert(translate("Komentár nemôže byť prázdny"));
            return;
        }

        this.api.request({
            route: "submit_comment",
            params: { oppositionID: this.props.data.id },
            data: { text: this.state.comment },
            created: (response) => {
                this.props.list.reload();
                this.setState({ comment: "" });
                window.dispatchEvent(new Event("reloadLog"));
            }
        })
    }

    renderCommentForm() {

        const commentCount = this.props.data.comments.length;
        //const isCommentable = getUser().role >= 5 && (this.props.data.commentable === true || this.props.data.commentable === "true");

        const commentableByToptest = commentCount === 0 && getUser().role >= 5 && (this.props.data.commentable === true || this.props.data.commentable === "true");
        const commentableByClient = commentCount === 1 && getUser().role === parseInt(this.props.data.user.role, 10) && (this.props.data.commentable === true || this.props.data.commentable === "true") && ["in_progress", "verified", "closed"].indexOf(this.props.list.props.test.status_val) !== -1;
        const commentableByBranch = commentCount === 1 && getUser().role === parseInt(this.props.data.user.role, 10) && (this.props.data.commentable === true || this.props.data.commentable === "true") && ["in_progress", "verified", "done"].indexOf(this.props.list.props.test.status_val) !== -1;

        if (commentableByToptest) {
            return (
                <div>
                    <div className="form-group">
                        <label className="control-label">{translate("Odpoveď TOPTEST")} <i>{getUser().name + " " + getUser().surname}</i></label>
                        <textarea className="form-control" value={this.state.comment} onChange={this.onCommentChange.bind(this)} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" onClick={this.onSubmitComment.bind(this)}>
                            <i className="fa fa-plus" />&nbsp;{translate("Pridať")}
                        </button>
                    </div>
                </div>
            )

        }

        if (commentableByClient && getUser().role === 3) {
            return (
                <div>
                    <div className="form-group">
                        <label className="control-label">{translate("Stanovisko")} <i>{getUser().name + " " + getUser().surname}</i></label>
                        <textarea className="form-control" value={this.state.comment} onChange={this.onCommentChange.bind(this)} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" onClick={this.onSubmitComment.bind(this)}>
                            <i className="fa fa-plus" />&nbsp;{translate("Pridať")}
                        </button>
                    </div>
                </div>
            )
        }

        if (commentableByBranch && getUser().role === 2) {
            return (
                <div>
                    <div className="form-group">
                        <label className="control-label">{translate("Stanovisko")} <i>{getUser().name + " " + getUser().surname}</i></label>
                        <textarea className="form-control" value={this.state.comment} onChange={this.onCommentChange.bind(this)} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" onClick={this.onSubmitComment.bind(this)}>
                            <i className="fa fa-plus" />&nbsp;{translate("Pridať")}
                        </button>
                    </div>
                </div>
            )
        }

        return <span />;
    }


    render() {
        return (
            <CollapsiblePanel title={(this.props.data.status === "draft" ? <span>{this.props.data.name}<small> {translate("(koncept)")}</small></span> : this.props.data.name)} expanded={false}>
                <div className="objection">
                    <div className="objection__meta">
                        <span>
                            <strong>{translate("Námietka")}</strong>&nbsp;<small>{this.props.data.user.name}</small> &#9702;&nbsp;
                            <small>{this.props.data.created}</small>&nbsp;
                            <OppositionFormEdit reload={this.props.list.reload.bind(this.props.list)} data={this.props.data} open={this.state.showModal} />
                        </span>
                    </div>
                    <span>{this.props.data.text}</span>
                </div>

                {this.props.data.comments.map((comment, index) => {

                    let title = "";

                    if (index === 0) {
                        title = translate("Odpoveď");
                    } else if (index === 1) {
                        title = translate("Stanovisko");
                    }

                    let canEdit = false;

                    if ([3, 5, 6, 7].indexOf(getUser().role) !== -1) {
                        canEdit = ["in_progress", "verified", "closed"].indexOf(this.props.list.props.test.status_val) !== -1;
                    }

                    if ([2, 5, 6, 7].indexOf(getUser().role) !== -1) {
                        canEdit = ["in_progress", "verified", "done"].indexOf(this.props.list.props.test.status_val) !== -1;
                    }

                    return (
                        <div className="objection" key={index}>
                            <div className="objection__meta">
                                <span>
                                    <strong>{title}</strong>&nbsp;<small>{comment.user}</small> &#9702;&nbsp;
                                    <small>{comment.created}</small>&nbsp;
                                    {canEdit ? <OppositionCommentFormEdit
                                        reload={this.props.list.reload.bind(this.props.list)}
                                        comment={comment}
                                        open={this.state.showModal} /> : ""}
                                </span>
                            </div>
                            <span>{comment.text}</span>
                        </div>
                    )
                })}

                {this.renderCommentForm()}
            </CollapsiblePanel>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/opposition/OppositionItem.jsx